<template>
    <UIGallery :items="galleryItems" />
</template>

<script lang="ts" setup>
    import videoCoverImage from '@/assets/images/cars/video-cover.webp';

    import { computed, PropType } from 'vue';

    import { Auction } from '@/types/auction/auction.type.ts';
    import { CarPhoto, CarVideo } from '@/types/car.type.ts';

    import UIGallery from '@/components/ui/UIGallery/UIGallery.vue';

    const { auction } = defineProps({
        auction: {
            type: Object as PropType<Auction>,
            required: true,
        },
    });

    const galleryItems = computed(() => {
        const items: {
            src: string,
            thumb: string,
            type: string,
            content_type: string,
        }[] = [];

        auction.car.photos?.forEach((photo: CarPhoto) => {
            items.push({
                src: photo.path,
                thumb: photo.path_small,
                type: 'image',
                content_type: photo.content_type,
            });
        });

        auction.car.videos?.forEach((video: CarVideo) => {
            items.push({
                src: video.path,
                thumb: videoCoverImage,
                type: 'video',
                content_type: video.content_type,
            });
        });

        return items;
    });
</script>
